const Introduction = () => {
    return (
        <div className="Introduction">
            <div className="name">
                <div className="intro">
                    <img
                        className="image"
                        src="./images/intro.png"
                        alt="intoImage"></img>
                </div>
                <div className="intro">
                    <h1 className="Intro_h1">FITNESS BUDDY</h1>
                    <pre className="Intro_h2">
                        <b>
                            "YOUR FITNESS JOURNEY STARTS HERE!"
                        </b>
                    </pre>
                </div>
            </div>
            <div className="account">
                <p>Ready to sign up ?</p>
                <a href="/signup" className="btn creAccBtn">
                    CREATE ACCOUNT
                </a>
                <p className="account_l">
                    Already a member?
                    <a href="/login" className="btn">
                        Log In
                    </a>
                </p>
            </div>
        </div>
    );
};
export default Introduction;
